import React from "react";

const SvgRegularIcon = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width || "1em"}
      height={width || "1em"}
      viewBox="0 0 65 80"
      style={style}
      fill="currentColor"
    >
      <defs />
      <defs>
        <clipPath id="clip-regular">
          <path d="M0 0h65v80H0z" />
        </clipPath>
      </defs>
      <g id="regular" clip-path="url(#clip-regular)">
        <g id="bold_1_" data-name="bold (1)">
          <path
            id="Path_38528"
            d="M45.931 80a3 3 0 01-2.994-2.994V2.994a2.994 2.994 0 015.988 0v74.012A3 3 0 0145.931 80zm0 0"
            data-name="Path 38528"
            transform="translate(-34.954)"
          />
          <path
            id="Path_38529"
            d="M40.453 41H12.471a2.994 2.994 0 110-5.988h27.982a14.624 14.624 0 0014.723-14.49A14.632 14.632 0 0040.453 5.988H3.32A3.024 3.024 0 01.27 2.994 3.024 3.024 0 013.32 0h37.133a20.676 20.676 0 0120.824 20.478A20.684 20.684 0 0140.453 41zm0 0"
            data-name="Path 38529"
            transform="translate(-.27)"
          />
          <path
            id="Path_38530"
            d="M42.438 232.066H3.316a2.994 2.994 0 110-5.988h39.122a16.512 16.512 0 100-33.021H12.457a2.994 2.994 0 110-5.988h29.981a22.5 22.5 0 110 45zm0 0"
            data-name="Path 38530"
            transform="translate(-.27 -152.067)"
          />
        </g>
      </g>
    </svg>
  );
};

export default SvgRegularIcon;
